var map = {
	"./Completed.svg": 20378,
	"./Eaii.png": 83583,
	"./EaiiLoginicon.png": 32855,
	"./Home-icon.png": 36542,
	"./Leader.png": 57244,
	"./Loginbackground.png": 18896,
	"./Logo.png": 33690,
	"./Member-icon.png": 24119,
	"./Member1.png": 31620,
	"./Notification-icon.png": 69222,
	"./Org-icon.png": 87283,
	"./PDF file icon.png": 89248,
	"./Profile-pic.png": 58783,
	"./Project-icon.png": 30068,
	"./Reset_logo.png": 76602,
	"./Role-icon.png": 7245,
	"./Search-icon.png": 78105,
	"./Team-icon.png": 88,
	"./Trash-icon.png": 56463,
	"./Vector.svg": 44010,
	"./Word file icon.png": 16274,
	"./assign.png": 30252,
	"./assigned.png": 4695,
	"./assignee.png": 31054,
	"./assignee2.png": 42334,
	"./assignee3.png": 18119,
	"./bg.png": 76054,
	"./browser.png": 24023,
	"./comment.png": 26144,
	"./comment2.png": 21456,
	"./completed.png": 2580,
	"./daysleft.png": 57433,
	"./downarrow.png": 64376,
	"./dropdownarrow.png": 5077,
	"./duration.png": 48063,
	"./email.png": 13175,
	"./ethiopian_civil_service_commistion_logo-removebg-preview (1).png": 2118,
	"./ethiopian_civil_service_commistion_logo.jpeg": 81444,
	"./ethiopian_civil_service_commistion_logo.png": 99507,
	"./facebook.png": 86675,
	"./instagram.png": 80739,
	"./linkedin.png": 15273,
	"./login_logo.png": 18260,
	"./logoo.png": 791,
	"./majortask.png": 82235,
	"./member10.png": 47742,
	"./member11.png": 66055,
	"./member3.png": 59094,
	"./member4.png": 9065,
	"./member5.png": 84864,
	"./member6.png": 82427,
	"./member7.png": 60882,
	"./member9.png": 78412,
	"./mypp.png": 69857,
	"./option.png": 91428,
	"./org_unit.png": 75812,
	"./pluss.png": 80212,
	"./sector.png": 82969,
	"./settinglogo.png": 59286,
	"./signin.png": 8937,
	"./telegram.png": 26998,
	"./trash.png": 23345,
	"./twitter.png": 11290,
	"./up.png": 20792,
	"./view-profile.png": 16508,
	"./view.png": 12236,
	"./warning.png": 72027,
	"./youtube.png": 64444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;